export const checkDevEnv = process.env.NODE_ENV === 'development' || window.location.hostname === 'neweb.bbservice.lt';